<template>
  <div style="overflow-y: scroll;" :style="bodyStyle2">

    <el-form :model="addForm" ref="addForm" :disabled='disabled'>

        <el-card>
          <div slot="header" class="clearfix">
            <span>一般情况</span>
          </div>

          <el-col :span="8" class="item">

            <el-form-item label="身高">
              <el-input v-model="addForm.stature" placeholder="请输入身高" clearable>
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>

            <el-form-item label="体重">
              <el-input v-model="addForm.weight" placeholder="请输入体重" clearable>
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>

            <el-form-item label="体质指数">
              <el-input v-model="addForm.constitution" placeholder="请输入体质指数" clearable>
                <template slot="append">kg/m²</template>
              </el-input>
            </el-form-item>

          </el-col>

          <el-col :span="8" class="item">
            <el-form-item label="臀围">
              <el-input v-model="addForm.hipLine" placeholder="请输入臀围" clearable>
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>

            <el-form-item label="腰围">
              <el-input v-model="addForm.waistLine" placeholder="请输入腰围" clearable>
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>

            <el-form-item label="腰臀围比值">
              <el-input v-model="addForm.whr" placeholder="请输入腰围" clearable>
              </el-input>
            </el-form-item>


          </el-col>

          <el-col :span="8" class="item">
            <el-form-item label="健康状况评价">
              <el-input v-model="addForm.healthStatus" placeholder="请输入健康状况评价" clearable>
              </el-input>
            </el-form-item>

            <el-form-item label="认知功能">
              <el-input v-model="addForm.cognitive" placeholder="请输入认知功能" clearable>
              </el-input>
            </el-form-item>

            <el-form-item label="情感状态">
              <el-input v-model="addForm.emotionStates" placeholder="请输入情感状态" clearable>
              </el-input>
            </el-form-item>

          </el-col>

        </el-card>

    </el-form>

    <div style="background-color: white;height: 80px; width: 100% " v-show="!disabled">
      <div style="margin-left: 43.5%;margin-top: 10px; ">
        <el-button type="primary" style="width: 26%" @click="confirm('addForm')">保存</el-button>
      </div>
    </div>

  </div>


</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {

  name: "Role",
  data() {
    return {
        disabled:false,

      bodyStyle2: "height:" + (this.$store.state.tableHeight-120) + 'px',

      addForm: {
        timeStr: timeStr,
        sign : hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        staffCode: getStaffCode(),
        symptom: '',
        symptomInfo: '',
        temperature: '',
        respiratory: '',
        stature: '',
        weight: '',
        constitution:'',
        pulseRate: '',
        bloodPressureLeft: '',
        bloodPressureRight: '',
        healthStatus: '',
        cognitive: '',
        hipLine: '',
        waistLine: '',
        whr: '',
        selfCareAbility: '',
        emotionStates: '',
        workingTime: '',
        occupationalDiseases: '',
        occupationalDiseasesType: '',
        dust: '',
        dustSafeguard: '',
        radiogen: '',
        radiogenSafeguard: '',
        logistics: '',
        logisticsSafeguard: '',
        chemistry: '',
        chemistrySafeguard: '',
        occupationalDiseasesElse: '',
        occupationalDiseasesElseSafeguard: '',
        lip: '',
        tooth: '',
        pharynx: '',
        leftVision: '',
        rightVision: '',
        adjustLeftVision: '',
        adjustRightVision: '',
        hearing: '',
        athletic: '',
        skin: '',
        sclera: '',
        barrelChest: '',
        breathSounds: '',
        rale: '',
        heartRate: '',
        noise: '',
        pressPain: '',
        masses: '',
        splenauxe: '',
        hepatomegaly: '',
        shiftingDullness: '',
        legsEdema: '',
        dorsalFoot: '',
        anus: '',
        breast: '',
        vulva: '',
        vagina: '',
        cervix: '',
        corpus: '',
        accessory: '',
        examine: '',
        elderlyCode:''
      },

      elderlyCode:''

    }
  },
  created() {

  },
  components: {},
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.bodyStyle2="height:" + (val-120) + 'px';
    },
  },
  methods: {
    init(userCode, elderlyCode) {

      this.isSave = true;
      this.elderlyCode = elderlyCode;

      if(!this.isSave){
        this.$refs.addForm.resetFields();
      }else{
        this.$refs.addForm.resetFields();
        this.getEHealth();
      }

    },

    confirm(addForm){
      if(!this.isSave){
        this.$refs[addForm].validate((valid) => {
          if (valid) {
            this.addSubmit();
          } else {
            this.$message({type: 'warning', message: '请完善信息'});
            return false;
          }
        })
      }else {
        this.$refs[addForm].validate((valid) => {
          if (valid) {
            this.editSubmit();
          } else {
            this.$message({type: 'warning', message: '请完善信息'});
            return false;
          }
        })
      }
    },

    addSubmit(){
      this.addForm.elderlyCode=this.elderlyCode;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "EHealthInfo/Add",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error === 0) {
              this.$message({type: 'success', message: '保存成功！'});
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },

    editSubmit(){
      this.addForm.elderlyCode=this.elderlyCode;
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "EHealthInfo/Edit",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error === 0) {
              this.$message({type: 'success', message: '保存成功！'});
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    getEHealth(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "EHealthInfo/GetEHealthInfo",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyCode:this.elderlyCode
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              // this.elData=response.data.data;
              if(response.data.data){
                this.elData=response.data.data;
                this.dataInit();
              }else{
                this.isSave=false

                this.addForm =  {
                  timeStr: timeStr,
                      sign : hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                      staffCode: getStaffCode(),
                      symptom: '',
                      symptomInfo: '',
                      temperature: '',
                      respiratory: '',
                      stature: '',
                      weight: '',
                      constitution:'',
                      pulseRate: '',
                      bloodPressureLeft: '',
                      bloodPressureRight: '',
                      healthStatus: '',
                      cognitive: '',
                      hipLine: '',
                      waistLine: '',
                      whr: '',
                      selfCareAbility: '',
                      emotionStates: '',
                      workingTime: '',
                      occupationalDiseases: '',
                      occupationalDiseasesType: '',
                      dust: '',
                      dustSafeguard: '',
                      radiogen: '',
                      radiogenSafeguard: '',
                      logistics: '',
                      logisticsSafeguard: '',
                      chemistry: '',
                      chemistrySafeguard: '',
                      occupationalDiseasesElse: '',
                      occupationalDiseasesElseSafeguard: '',
                      lip: '',
                      tooth: '',
                      pharynx: '',
                      leftVision: '',
                      rightVision: '',
                      adjustLeftVision: '',
                      adjustRightVision: '',
                      hearing: '',
                      athletic: '',
                      skin: '',
                      sclera: '',
                      barrelChest: '',
                      breathSounds: '',
                      rale: '',
                      heartRate: '',
                      noise: '',
                      pressPain: '',
                      masses: '',
                      splenauxe: '',
                      hepatomegaly: '',
                      shiftingDullness: '',
                      legsEdema: '',
                      dorsalFoot: '',
                      anus: '',
                      breast: '',
                      vulva: '',
                      vagina: '',
                      cervix: '',
                      corpus: '',
                      accessory: '',
                      examine: '',
                      elderlyCode:''
                }

              }
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )
    },

    dataInit(){
      this.addForm.temperature=this.elData.temperature;
      this.addForm.respiratory=this.elData.respiratory;
      this.addForm.stature=this.elData.stature;
      this.addForm.weight=this.elData.weight;
      this.addForm.constitution=this.elData.constitution;
      this.addForm.pulseRate=this.elData.pulseRate;
      this.addForm.bloodPressureLeft=this.elData.bloodPressureLeft;
      this.addForm.bloodPressureRight=this.elData.bloodPressureRight;
      this.addForm.hipLine=this.elData.hipLine;
      this.addForm.waistLine=this.elData.waistLine;
      this.addForm.whr=this.elData.whr;
      this.addForm.selfCareAbility=this.elData.selfCareAbility;
      this.addForm.healthStatus=this.elData.healthStatus;
      this.addForm.symptom=this.elData.symptom;
      this.addForm.emotionStates=this.elData.emotionStates;
      this.addForm.workingTime=this.elData.workingTime;
      this.addForm.symptomInfo=this.elData.symptomInfo;
      this.addForm.occupationalDiseasesType=this.elData.occupationalDiseasesType;
      this.addForm.dust=this.elData.dust;
      this.addForm.dustSafeguard=this.elData.dustSafeguard;
      this.addForm.radiogen=this.elData.radiogen;
      this.addForm.radiogenSafeguard=this.elData.radiogenSafeguard;
      this.addForm.logistics=this.elData.logistics;
      this.addForm.logisticsSafeguard=this.elData.logisticsSafeguard;
      this.addForm.chemistry=this.elData.chemistry;
      this.addForm.chemistrySafeguard=this.elData.chemistrySafeguard;
      this.addForm.occupationalDiseasesElse=this.elData.occupationalDiseasesElse;
      this.addForm.occupationalDiseasesElseSafeguard=this.elData.occupationalDiseasesElseSafeguard;
      this.addForm.lip=this.elData.lip;
      this.addForm.tooth=this.elData.tooth;
      this.addForm.pharynx=this.elData.pharynx;
      this.addForm.leftVision=this.elData.leftVision;
      this.addForm.rightVision=this.elData.rightVision;
      this.addForm.adjustLeftVision=this.elData.adjustLeftVision;
      this.addForm.adjustRightVision=this.elData.adjustRightVision;
      this.addForm.cognitive=this.elData.cognitive;
      this.addForm.occupationalDiseases=this.elData.occupationalDiseases;
      this.addForm.skin=this.elData.skin;
      this.addForm.sclera=this.elData.sclera;
      this.addForm.barrelChest=this.elData.barrelChest;
      this.addForm.breathSounds=this.elData.breathSounds;
      this.addForm.rale=this.elData.rale;
      this.addForm.heartRate=this.elData.heartRate;
      this.addForm.noise=this.elData.noise;
      this.addForm.pressPain=this.elData.pressPain;
      this.addForm.masses=this.elData.masses;
      this.addForm.splenauxe=this.elData.splenauxe;
      this.addForm.hepatomegaly=this.elData.hepatomegaly;
      this.addForm.shiftingDullness=this.elData.shiftingDullness;
      this.addForm.legsEdema=this.elData.legsEdema;
      this.addForm.dorsalFoot=this.elData.dorsalFoot;
      this.addForm.anus=this.elData.anus;
      this.addForm.breast=this.elData.breast;
      this.addForm.vulva=this.elData.vulva;
      this.addForm.vagina=this.elData.vagina;
      this.addForm.cervix=this.elData.cervix;
      this.addForm.corpus=this.elData.corpus;
      this.addForm.accessory=this.elData.accessory;
      this.addForm.examine=this.elData.examine;
      this.addForm.athletic=this.elData.athletic;
      this.addForm.hearing=this.elData.hearing;
    },


  }
}
</script>

<style lang="scss" scoped>


</style>
